"use client";

import { NewsletterForm } from "~/components/storefront/blocks/newsletter-form";
import { useTranslator } from "~/i18n/provider";

/**
 * P2-01 · Newsletter band in the footer. Submission is now real (P2-06j): it
 * renders the same `NewsletterForm` the homepage block uses, themed for the dark
 * footer band (inverse tone) and tagged with the `footer` source. Rendered only
 * when the brand enables the newsletter slot.
 */
export function NewsletterSignup() {
  const t = useTranslator();

  return (
    <NewsletterForm
      source="footer"
      tone="inverse"
      layout="inline"
      placeholder={t("footer.emailPlaceholder")}
      ctaLabel="Subscribe"
      successMessage={t("footer.newsletterThanks")}
    />
  );
}
